
// Vue
import {Options, Vue} from "vue-class-component";

// Components
import {
  ElRow,
  ElCol,
} from "element-plus";
import PlayerNavigationVue from "@/components/player/navigation.vue";
import AppPlayerHealthRecordsRootListIndexVue from "@/views/app/player/health-records/root/list/index.vue";

@Options({
  components: {
    ElRow,
    ElCol,
    PlayerNavigationVue,
    AppPlayerHealthRecordsRootListIndexVue,
  },
})
export default class AppPlayerHealthRecordsRootIndexVue extends Vue {}
